<template>
  <div class="groups-block" v-if="isHost && participantsConnected">
    <v-btn-toggle
      v-for="group in shownGroups"
      :key="group.id"
      rounded
      multiple
      class="group-btn mr-2"
    >
      <v-btn @click="showGroup(group)" :class="{ primary: group.shown }">
        {{ getGroupName(group) }}
      </v-btn>
      <v-btn
        v-if="!isEveryoneGroup(group)"
        @click="dropGroup(group)"
        class="close-group-btn"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-btn-toggle>

    <v-menu
      v-if="groupWithoutDefault.length && selectedParticipants.length"
      bottom
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-btn color="primary" v-on="on" class="ml-auto"> Add to Group </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="group in shownGroups"
          :key="group.id"
          @click="addToGroup(group)"
        >
          <v-list-item-title>
            {{ getGroupName(group) }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import GenericAction from './GenericAction';
import uuid from 'uuid';
import clone from 'lodash/clone';

export default {
  name: 'ActionGroup',
  mixins: [GenericAction],
  data() {
    return {
      title: 'Create Group',
      groups: [
        {
          name: 'Everyone',
          id: 'all',
          shown: true,
        },
      ],
    };
  },

  //TODO groups needs to be computed to get
  //a list of available participants and then filtered
  //to the original group of folks so that the counts
  //stay dynamic..
  computed: {
    shownGroups() {
      return this.groups;
    },
    groupWithoutDefault() {
      return this.groups.slice(1);
    },
    participantsCount() {
      return this.participants.length;
    },
  },

  methods: {
    isEveryoneGroup(group) {
      return group.id === 'all';
    },

    includedParticipants(group) {
      return this.participants.filter((part) => {
        return (
          part.groups.indexOf(group.id) !== -1 &&
          !this.isHostIdentity(part.identity)
        );
      });
    },

    groupParticipantsCount(group) {
      return (
        this.hostParticipants.length + this.includedParticipants(group).length
      );
    },

    getGroupName(group) {
      if (this.isEveryoneGroup(group)) {
        return `${group.name}  (${this.participantsCount})`;
      }
      return `Group of ${this.groupParticipantsCount(group)}`;
    },

    updateGroupForSelectedParticipants(parts, group) {
      let groups = ['all'];
      if (group) {
        groups.push(group.id);
      }

      parts.forEach((part) => {
        //let previousGroup = part.groups.find((g) => g !== 'all');
        let previousGroup = this.group.id;

        this.api.updateParticipantInfo(
          {
            identity: part.identity,
            selected: false,
            previousGroup,
            groups,
          },
          { to: 'host' }
        );
      });
    },

    showGroup(group) {
      let groups = this.groups.map((g) => {
        g.shown = false;
        return g;
      });

      this.groups = groups;
      group.shown = true;
      this.updateParticipantInfoForGroup(group);
      this.api.setCurrentGroup(group);
    },

    dropGroup(group) {
      this.api.removeGroup(group);

      let participants = this.includedParticipants(group);
      //remove custom group for participants
      this.updateGroupForSelectedParticipants(participants, false);

      let groups = this.shownGroups;
      let everyone = groups[0];

      this.updateParticipantInfoForGroup(everyone);
      //TODO change to group just left of this group?

      let groupIndex = groups.findIndex((g) => g.id === group.id);

      let currentGroup = groups.slice(groupIndex - 1, groupIndex).pop();
      currentGroup = currentGroup || everyone;
      this.showGroup(currentGroup);

      this.setGroups(groups.filter((g) => g.id !== group.id));
    },

    updateParticipantInfoForGroup(group, options = null) {
      let groupParticipants = this.includedParticipants(group);

      this.participants.forEach((part) => {
        let included = groupParticipants.find((ap) => {
          return ap.identity === part.identity;
        });

        this.api.updateParticipantInfo(
          {
            identity: part.identity,
            selected: false,
            hidden: !included,
            showSelection: true,
          },
          options
        );
      });
    },

    selected() {
      let group = {
        shown: true,
        id: uuid.v1(),
      };

      this.groups.push(group);

      this.updateGroupForSelectedParticipants(this.activeParticipants, group);
      this.validateGroups();
      this.showGroup(group);
    },

    //make sure groups have people otherwise drop connections
    validateGroups() {
      let groups = [];

      this.groups.forEach((g) => {
        const included = this.includedParticipants(g).length;
        if (!included) return this.api.removeGroup(g);
        groups.push(g);
      });

      this.setGroups(groups);
    },

    async groupsStateUpdated(groups) {
      let currentGroup = groups.find((g) => g.id === this.group.id);
      this.showGroup(currentGroup || groups[0]);
    },

    received(invite) {},

    setGroups(groups) {
      this.groups = groups;
      this.sendGroupsState();
    },

    sendGroupsState() {
      let groups = this.groups.map((g) => {
        g = clone(g);
        g.shown = false;
        return g;
      });
      this.api.trigger('stateChange', { groups });
    },

    addToGroup(group) {
      this.updateGroupForSelectedParticipants(this.selectedParticipants, group);
      this.showGroup(group);
    },

    initGroups() {
      this.api.on('stateUpdate', (state) => {
        if (state.groups) {
          this.groupsStateUpdated(state.groups);
        }
      });

      this.api.on('sendState', () => {
        this.sendGroupsState();
      });
    },
  },

  created() {
    this.initGroups();
  },
};
</script>

<style>
.groups-block {
  padding: 16px 12px 12px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.v-btn-toggle.group-btn {
  display: inline-block;
  width: auto !important;
}
.v-btn.close-group-btn {
  min-width: 48px !important;
}
</style>
